import { graphql } from "@opensea/graphql"
import { getMediaPropsFromMediaFragment } from "../../../../utils"
import { TextOnlyFragment } from "../TextOnly/TextOnly.fragment"

export const TextWithMediaFragment = graphql(
  `
    fragment TextWithMedia on CollectionNarrativeModule {
      horizontalTextPosition
      ...TextOnly
      media {
        __typename
        ...MediaProps
      }
    }
  `,
  [getMediaPropsFromMediaFragment, TextOnlyFragment],
)
